<template>
  <div>
    <rs-dialog title="引入账户" :visible.sync="showDialogAccount" width="70%" :before-close="handleClose">
      <renderForm :list="ruleForm" ref="ruleFormRef" :formData.sync="ruleFormData" :show-message="false">
        <template v-slot:operation>
          <rs-button type="primary" @click="onSearch">查询</rs-button>
          <rs-button type="text" @click="resetFields">清空条件</rs-button>
        </template>
      </renderForm>
      <!-- 表格内容 -->
      <div class="table-wrap">
        <rs-table :data="tempData" border @selection-change="rowClick" ref="contractTable">
          <rs-table-column type="selection" width="55"></rs-table-column>
          <rs-table-column type="index" label="序号" align="center" width="46"></rs-table-column> 
          <rs-table-column label="BIP账号" show-overflow-tooltip prop="bipCode" align="center"></rs-table-column>
          <rs-table-column label="部门" show-overflow-tooltip prop="orgName" align="center"></rs-table-column>
          <!-- <rs-table-column label="职位" show-overflow-tooltip prop="idNumber" align="center"></rs-table-column> -->
          <rs-table-column label="姓名" show-overflow-tooltip prop="userName" align="center"></rs-table-column>
          <rs-table-column label="状态" show-overflow-tooltip prop="userStatus" align="center" :formatter="formatStatus"></rs-table-column>
        </rs-table>
        <rs-button type="primary" @click="addERP" style="margin:10px">添加到ERP</rs-button>
      </div>
      <Pagination :pageNo="pageNo" :pageSize="pageSize" :pageTotal="pageTotal" @getSizeChange="handleSizeChange" @getCurrentChange="handleCurrentChange" />
      <!-- <span slot="footer" class="dialog-footer">
        <rs-button @click="onButton('取消')" size="small">取 消</rs-button>
        <rs-button type="primary" @click="onButton('确定')" size="small">确 定</rs-button>
      </span> -->
    </rs-dialog>
  </div>
</template>

<script>
import Http from "@/api/account";
import mixin from "@/utils/mixin.js";
import Pagination from "./Pagination";
export default {
  props: {
    showDialogAccount: {
      type: Boolean,
      default: () => false,
    },
  },
  components:{
    Pagination
  },
  mixins: [mixin],
  data() {
    return {
      ruleForm: [],
      ruleFormData:{
        lesseeName:"",
        contractCode:"",
        boothCode:"",
      },
      pageSize: 10,
      pageNo: 1,
      pageTotal: 1,
      tempData:[],  // 表格
      tableRow:[],  // 多选
    };
  },
  created(){
    this.onSearch()
    this.renderPage()
  },
  watch: {},
  methods: {
    // 传递父级否则报错
    handleClose(done) {
      this.$emit("close");
    },
    // 判断点击弹窗确定和取消的按钮
    onButton(val){
      this.$emit("close")
    },
    formatStatus(row, column) {
      return row.userStatus==="0"?"离职":row.userStatus==="2"?"退休":row.userStatus==="3" ? "在职":row.userStatus;
    },
    onSearch() {
      this.pageNo = 1;
      this.getData();
    },
    getData(){
      Http.getBipUserList({
        ...this.ruleFormData,
        pageNum: this.pageNo,
        pageSize: this.pageSize,
      }).then(res=>{
        console.log(res.data.data);
        const { pageNum,pageSize,list,total} = res.data.data;
        // 处理数据返回的字段
        this.tempData = list
        this.pageNo = pageNum;
        this.pageSize = pageSize;
        this.pageTotal = total;
      })
    },
    // 表格单选
    rowClick (item) {
      console.log(item,"多选信息");
      this.tableRow = item
    },
    addERP(){
      console.log(this.tableRow);
      Http.addUserInfo(this.tableRow).then(res=>{
        console.log(res.data.data);
        if(res.data.code==200){
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.$emit("close")
          this.$emit("update")
          this.onSearch()
        }
      })
    },
    // 清空
    resetFields() {
      this.resetForm(["mallCode", "mallName"]);
      this.$refs.ruleFormRef.resetFields();
    },
    resetForm(ruleOutArr = []) {
      //改变项目重置所有数据
      this.ruleFormData = {
        lesseeName:"",
        contractCode:"",
        boothCode:"",
      }
    },
    renderPage(){
      this.ruleForm = [
        {
          type: "input",
          span: 6,
          label: "BIP账号",
          key: "bipCode"
        },
        {
          type: "input",
          span: 6,
          label: "姓名",
          key: "userName"
        },
        {
          type: "select",
          span: 6,
          label: "状态",
          key: "userStatus",
          optionList: [
            {
              label: "离职",
              value: "0"
            },
            {
              label: "退休",
              value: "2"
            },
            {
              label: "在职",
              value: "3"
            },
          ]
        },
        {
          slot: "operation"
        }
      ]
    }
  },
};
</script>

<style lang="less">
.rs-tooltip__popper{
  font-size: 14px; max-width:87%
}
</style>